// extracted by mini-css-extract-plugin
export default {"font_button_l":"font_button_l___CtYh8","font_button_m":"font_button_m___B1fna","font_button_s":"font_button_s___R_vUE","tag":"tag___ubfVx","transparent":"transparent___WhoaE"};